const PROD_LANES = ['pr1'];
const Q1_LANES = ['i1', 'u1', 'pl1'];

// Returns the ICE help site URL for a lane; production lanes use the bare domain.
export const getHelpUrl = (laneTag: string) => {
  if (Q1_LANES.includes(laneTag)) {
    return 'https://help.mortgagetech.q1.ice.com';
  }
  if (PROD_LANES.includes(laneTag)) {
    return 'https://help.mortgagetech.ice.com';
  }
  return `https://help.mortgagetech.${laneTag}.ice.com`;
};
